// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-5da42de2]{background:var(--color-card-background);border:1px solid var(--color-silver-screen-1);border-radius:var(--border-radius-2);display:block}.card[href][data-v-5da42de2]:hover{border-color:var(--color-card-background);box-shadow:var(--box-shadow-elevated)}.card.card-default[data-v-5da42de2]{padding:var(--size-3)}.card.card-compact[data-v-5da42de2]{padding:var(--size-2)}.card.card-no-padding[data-v-5da42de2]{padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
